import { render, staticRenderFns } from "./blacklistCompaniesComponent.vue?vue&type=template&id=cdf24d0e&"
import script from "./blacklistCompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./blacklistCompaniesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports